export * from './core-value'
export * from './rating-value'
export * from './type-map'
export * from './form-lookups'



// WEBPACK FOOTER //
// ./src/app/front-face/shared/review/index.ts